if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      const idInput = this.form.querySelector('[name=id]');
      if (idInput) idInput.disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return;

      this.handleErrorMessage();
      if (this.cartNotification && typeof this.cartNotification.setActiveElement === 'function') {
        this.cartNotification.setActiveElement(document.activeElement);
      }

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');
      const spinner = this.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      const payload = JSON.parse(serializeForm(this.form));
      if (this.cartNotification && typeof this.cartNotification.getSectionsToRender === 'function') {
        payload.sections = this.cartNotification.getSectionsToRender().map((section) => section.id);
        payload.sections_url = window.location.pathname;
      }
      config.body = JSON.stringify(payload);

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          if (this.cartNotification && typeof this.cartNotification.renderContents === 'function') {
            this.cartNotification.renderContents(response);
          } else {
            this.updateHeaderCartCount();
            this.flashAddedFeedback(submitButton);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    updateHeaderCartCount() {
      fetch('/cart.js')
        .then((r) => r.json())
        .then((cart) => {
          const count = cart.item_count;
          document.querySelectorAll('.yv-header__icon--cart').forEach((icon) => {
            let badge = icon.querySelector('.yv-header__cart-count');
            if (count > 0) {
              if (!badge) {
                badge = document.createElement('span');
                badge.className = 'yv-header__cart-count';
                icon.appendChild(badge);
              }
              badge.textContent = count;
            } else if (badge) {
              badge.remove();
            }
          });
        })
        .catch(() => {});
    }

    flashAddedFeedback(button) {
      const span = button.querySelector('span');
      if (!span) return;
      if (button.dataset.yvOriginalLabel === undefined) {
        button.dataset.yvOriginalLabel = span.textContent;
      }
      span.textContent = 'Added to Cart ✓';
      clearTimeout(button._yvFlashTimer);
      button._yvFlashTimer = setTimeout(() => {
        span.textContent = button.dataset.yvOriginalLabel;
      }, 1600);
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage && this.errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
